import type { PresetListItem } from "@vms/tubeforge-shared";
import { apiGet } from "./client.ts";

export const presetsApi = {
  // (session 7 §7e: with the business, `recommended` is ranked by what it is ready for)
  list: (strategyId?: string) => apiGet<{ presets: PresetListItem[]; recommended?: string[] }>(`/presets${strategyId ? `?strategyId=${encodeURIComponent(strategyId)}` : ""}`),
};
